import React from 'react';
import moment from 'moment';
import AuditEntity from './AuditEntity';

export default class DocumentAttachmentEntity {

  static types = ['PDF', 'PICTURE', 'VIDEO', 'XLSX', 'PPTX', 'LINK'];

  static shape = {
    id: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    type: React.PropTypes.oneOf(DocumentAttachmentEntity.types),
    fileName: React.PropTypes.string.isRequired,
    loading: React.PropTypes.bool,
    updating: React.PropTypes.bool,
    audit: React.PropTypes.shape(AuditEntity.shape),
    documentStartDate: React.PropTypes.string,
  };

  constructor(item, document) {
    Object.assign(this, item);
    this.documentStartDate = document && document.startDate;
  }

  static validate = (formValues) => {
    if (!formValues) {
      return null;
    }

    const errors = {};
    let hasError = false;

    if (!formValues.title) {
      errors.title = 'Titre obligatoire';
      hasError = true;
    }

    if (!formValues.file) {
      errors.file = 'Document obligatoire';
      hasError = true;
    } else if (formValues.file.typeLink) {
      if (!formValues.file.name) {
        errors.file = 'Lien obligatoire';
        hasError = true;
      } else if (!formValues.file.name.match(/^https?:\/\/.+$/i)) {
        errors.file = 'Lien invalide';
        hasError = true;
      }
    } else if (formValues.file.size > 35000000) {
      errors.file = 'Taille limite du document : 35Mo';
      hasError = true;
    }

    return hasError ? errors : null;
  };

  get isNew() {
    return !this.isUpdated
      && this.audit && this.audit.creationDateTime && this.documentStartDate
      && moment(this.audit.creationDateTime).startOf('day').isAfter(this.documentStartDate)
      && moment().diff(this.audit.creationDateTime, 'weeks') === 0;
  }

  get isUpdated() {
    return this.audit && this.audit.creationDateTime && this.audit.updateDateTime
      && this.audit.creationDateTime !== this.audit.updateDateTime
      && moment(this.audit.updateDateTime).isAfter(this.audit.creationDateTime)
      && moment().diff(this.audit.updateDateTime, 'weeks') === 0;
  }

}



// WEBPACK FOOTER //
// ./shared/src/entity/DocumentAttachmentEntity.js